import { injectable, inject } from "inversify";
import type { IBillingService, ContainerBilling } from "@/interfaces/IBillingService";
import type { IEmploymentHttpClient } from "@/interfaces/IEmploymentService";
import { TYPES } from "@/types";

@injectable()
export class BillingService implements IBillingService {
  private httpClient: IEmploymentHttpClient;

  constructor(
    @inject(TYPES.IEmploymentHttpClient) httpClient: IEmploymentHttpClient
  ) {
    this.httpClient = httpClient;
  }

  async getContainerBilling(containerId: number): Promise<ContainerBilling> {
    const data = {
      action: "GetContainerBillingQuery",
      data: { containerId }
    };
    const response = await this.httpClient.post(data);
    return response.data as ContainerBilling;
  }

  async setBillingType(
    containerId: number,
    billingType: 'monthly' | 'points'
  ): Promise<ContainerBilling> {
    const data = {
      action: "SetBillingTypeCommand",
      data: { containerId, billingType }
    };
    const response = await this.httpClient.post(data);
    return response.data as ContainerBilling;
  }

  async addPoints(
    containerId: number,
    points: number,
    description: string
  ): Promise<ContainerBilling> {
    const data = {
      action: "AddPointsCommand",
      data: { containerId, points, description }
    };
    const response = await this.httpClient.post(data);
    return response.data as ContainerBilling;
  }

  async removePoints(
    containerId: number,
    points: number,
    description: string
  ): Promise<ContainerBilling> {
    const data = {
      action: "RemovePointsCommand",
      data: { containerId, points, description }
    };
    const response = await this.httpClient.post(data);
    return response.data as ContainerBilling;
  }
}